module.exports = __webpack_public_path__ + "img/wa-icon.1af81570.svg";